var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseProgramQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14062 12.0626C7.625 12.2345 7.00781 12.3204 6.28906 12.3204C4.78906 12.3204 3.54948 11.8725 2.57031 10.9767C1.38281 9.89856 0.789062 8.31523 0.789062 6.22668C0.789062 4.12252 1.39844 2.53137 2.61719 1.45325C3.61198 0.573039 4.84896 0.132935 6.32812 0.132935C7.81771 0.132935 9.06771 0.59908 10.0781 1.53137C11.2448 2.6095 11.8281 4.11731 11.8281 6.05481C11.8281 7.08085 11.7031 7.94023 11.4531 8.63293C11.25 9.29439 10.9505 9.84387 10.5547 10.2814L11.8828 11.5236L10.625 12.8361L9.23438 11.5236C8.8125 11.7788 8.44792 11.9585 8.14062 12.0626ZM7.625 9.9845L6.46094 8.87512L7.70312 7.57825L8.86719 8.68762C9.04948 8.31262 9.17708 7.9845 9.25 7.70325C9.36458 7.28137 9.42188 6.78918 9.42188 6.22668C9.42188 4.93502 9.15625 3.93762 8.625 3.2345C8.09896 2.52616 7.32812 2.172 6.3125 2.172C5.35938 2.172 4.59896 2.51054 4.03125 3.18762C3.46354 3.86471 3.17969 4.87773 3.17969 6.22668C3.17969 7.80481 3.58594 8.93502 4.39844 9.61731C4.92448 10.06 5.55469 10.2814 6.28906 10.2814C6.5651 10.2814 6.83073 10.2475 7.08594 10.1798C7.22656 10.1434 7.40625 10.0782 7.625 9.9845Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseProgramQ);
export default __webpack_public_path__ + "static/media/icon_course_program_q.6f5d3d16adaada24975f4710ef2f7394.svg";
export { ForwardRef as ReactComponent };